import qs from 'qs'
import request from '@/utils/request'

/**
 * @param {{name?: string, email?: string, "region.id": number, "region.same": boolean}} params
 * @returns {{users: User[]}}
 */
export function getUsers(params) {
  return request({
    url: `/api/users/`,
    method: 'get',
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}

export function getVrioUsers(params) {
  return request({
    url: `/api/users/vrio/`,
    method: 'get',
    params,
  })
}

export function postVrioUser(data) {
  return request({
    url: `/api/users/vrio/`,
    method: 'post',
    data,
  })
}

export function getTokenVrioUser(id) {
  return request({
    url: `/api/users/vrio/${id}/cookie`,
    method: 'get',
  })
}

export function deleteVrioUser(id) {
  return request({
    url: `/api/users/vrio/${id}/`,
    method: 'delete',
  })
}

export function patchVrioUser(id, data) {
  return request({
    url: `/api/users/vrio/${id}/`,
    method: 'patch',
    data,
  })
}
